module.exports = __webpack_public_path__ + "static/media/templatethree3.8dc26740.png";